import { updateField } from 'vuex-map-fields';
import types from './mutations-types';

const mutations = {
  updateField,
  [types.SET_ALL_ACTION_GROUPS](state, payload) {
    state.allGroups = payload;
  },
  [types.SET_ALL_ACTIONS](state, payload) {
    state.allActions = payload;
  },
  [types.SET_ACTIONS_IDS](state, payload) {
    state.actionsIds = payload;
  },
  [types.SET_ACTION_LIST](state, payload) {
    state.actionList = payload.actions;
    state.totalActionList = payload.total;
  },
  [types.SET_ACTION_DETAILS](state, payload) {
    state.actionDetails = payload;
  },
  [types.SET_ACTION](state, payload) {
    state.action = {
      ...state.action,
      ...payload,
    };
  },
  [types.SET_SMS_MESSAGE_LINK](state, payload) {
    state.action.smsMessageLink = payload;
  },
  [types.SET_SMS_MESSAGE](state, payload) {
    state.action.smsMessage = payload;
  },
  [types.SET_SMS_SUBJECT](state, payload) {
    state.action.smsSubject = payload;
  },
  [types.SET_ACTION_UPLOADED_IMAGE](state, payload) {
    state.action.uploadedImage = payload;
  },
  [types.SET_REPLYS](state, payload) {
    state.action.reply.detractors = payload.detractors;
    state.action.reply.neutral = payload.neutral;
    state.action.reply.promoters = payload.promoters;
  },
  [types.SET_EMAIL_SUBJECT](state, payload) {
    state.action.email.subject = payload;
  },
  [types.SET_EMAIL_FROM](state, payload) {
    state.action.email.from = payload;
  },
  [types.SET_TEST_NPS_REVIEW](state, payload) {
    state.testNpsReview = payload;
  },
  [types.SET_ALERT_RULES](state, payload) {
    state.action.alertRules = {
      ...payload,
    };
  },
  [types.SET_KEYWORD_RULES](state, payload) {
    console.log('payload', payload);
    state.action.keywordsAlertId = payload;
  },
  [types.SET_QUARENTINE](state, payload) {
    state.action.quarentine = {
      ...payload,
    };
  },
  [types.SET_LIST_ID](state, payload) {
    if (state.listId === null) {
      state.listId = payload;
    }
  },
  [types.SET_NPS_BY_ACTION](state, payload) {
    state.ActionNps = payload.nps;
    state.ActionNpsRound = payload.npsRound;
  },
  [types.SET_ACTION_WORD_CLOUD](state, payload) {
    state.actionWordCloud = payload;
  },
  [types.SET_ACTION_QUESTION](state, payload) {
    state.action.question = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/actions/mutations.js